export enum ErrorType {
  GET_ERROR = 'errorGettingData'
}

export interface PlatformResponse<T> {
  data: T;
  status: number;
  success: boolean;
  error: {
    type: string;
    message: string;
    code: string;
  }[];
}
